import React from "react";

const AppFooter = (props: any) => {
    return (
        <div className="layout-footer">
            <div className="footer-logo-container">
                {/* <img id="footer-logo" src={`assets/layout/images/logo-${props.colorScheme === "light" ? "dark" : "light"}.png`} alt="atlantis-layout" />
                <span className="app-name">Vamos CAP</span> */}
            </div>
            <span className="copyright">&#169; Vamos CAP 2022 - {new Date().getFullYear()}</span>
        </div>
    );
};

export default AppFooter;
